module.exports = __webpack_public_path__ + "static/media/grab.473e1dc9.png";